module.exports = __webpack_public_path__ + "caa7b9642beccc7268c91a39da96bf3e.png";